import debounce from "lodash.debounce";


export default {
  name: 'SearchWindowComp',
  components: {
    FiltersComp: require('@/employee/captureMeterReadings/filters/filters.vue').default,
    ReadingsListCell: require('./readingsListCell.vue').default,
  },
  props: {
    readings: {
      type: Array,
    },
    showSearchDialog: {
      type: Boolean,
      default: false,
    },
    readingSelectedFunc: {
      type: Function
    },
    saveSearch: {
      type: Boolean,
      default: false
    },
    isPropertyOriented: {
      type: Boolean,
      default: false
    },
    saveFilters: {
      type: Function,
      required: true
    }
  },
  data: function () {
    return {
      filteredReadings: [],
      readingsSearchResults: [],
      searchObj: { ConsumerTypeId: '', TenantName: '', Address: '', PropRef: '', SerialNo: '', },
      loadSearchList: false,
      loadSearchListIsDisabled: false,
      advancedSearchResults: [],
      offlineSearchType: 'meterNo',
      offlineSearchText: '',
      lastSelectedReading: null,
      emptySearch: false,
      isSearched: false,

      filtersDataObj: {
        trim: { readUnread: "0", withNote: false, withAccess: false, disconnected: true, discrepancy: false },
        readings: [],
        spotBillEnabled: false,
        filteredReadings: [],
        showDialog: false,
        saveFilters: this.saveFilters
      },
    }
  },
  computed: {    
    filteredReadingsLength: function () {
      return this.filtersDataObj && this.filtersDataObj.filteredReadings ? this.filtersDataObj.filteredReadings.length : 0;
    }
  },
  watch: {
    filteredReadingsLength: function (val) {
      if (!val)
        return;
      this.filteredReadings = [...this.filtersDataObj.filteredReadings];
      this.advancedFilterReadings();
    },
    offlineSearchText: function (val) {
      if (val && this.emptySearch) {
        this.emptySearch = false;
      }

      this.debouncedFunc();
    },
    offlineSearchType: function (val) {
      this.advancedFilterReadings();
    },
    showSearchDialog: function (val) {
      if (val) {
        if (this.advancedSearchResults.length == 1) {
          //this.close();
          return;
        }

        if (this.advancedSearchResults != null && this.advancedSearchResults.length > 0 &&
          this.lastSelectedReading != null && this.lastSelectedReading.meterId != null && this.lastSelectedReading.meterId != '') {
          setTimeout(() => {
            this.scrollToElement(this.lastSelectedReading.meterId);
          }, 1000);
        }

        if (this.saveSearch) {
          this.loadSearchData();
        }
      }
    }
  },
  created() {
    this.debouncedFunc = debounce(() => {
      this.advancedFilterReadings();
    }, 500);

  },
  mounted() {
    if (this.saveSearch === true)
      this.loadSearchData();

    this.isSearched = false;
    this.filtersDataObj['readings'] = this.readings;

    this.$root.$on('reset_advanced_search', this.clearAdvancedSearch);
  },
  beforeUnmount() {
    this.debounceFunc.cancel();
  },
  methods: {
    scrollToElement(elem) {
      if (!elem)
        return;

      let e = document.getElementById(elem);

      if (!e)
        return;

      e.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' })

    },
    loadSearchData() {
      let t = this.$store.state.captureMeterReadingsSearch;

      if (t != null && t.offlineSearchText != null && t.offlineSearchType != null && t.offlineSearchText != '' && t.offlineSearchType != '') {
        this.offlineSearchType = t.offlineSearchType;
        this.offlineSearchText = t.offlineSearchText;
        this.advancedFilterReadings();
      }
    },
    advancedFilterReadings() {
      this.offlineSearchText = this.offlineSearchText.trim();
      this.isSearched = true;

      if (this.offlineSearchText == null || this.offlineSearchText == '') {
        this.emptySearch = true;
        this.advancedSearchResults = [];
        return;
      }

      this.emptySearch = false;
      this.advancedSearchResults = [...this.filteredReadings];

      switch (this.offlineSearchType) {
        case 'propRef':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.propRef.includes(this.offlineSearchText));
          break;
        case 'propAddr':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.propertyAddress != null ? r.propertyAddress.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().
            includes(this.offlineSearchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) : false);
          break;
        case 'tenantName':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.tenantName != null ? r.tenantName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
            .includes(this.offlineSearchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) : false);
          break;
        case 'consumerType':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.consumerType != null ? r.consumerType.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
            .includes(this.offlineSearchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) : false);
          break;
        case 'meterNo':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.meterRef != null ?
            r.meterRef.includes(this.offlineSearchText) : false);
          break;
        case 'customerNo':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.account != null ?
            r.account.includes(this.offlineSearchText) : false);
          break;
        case 'bulkMeterNo':
          let temp = this.advancedSearchResults.filter(s => s.meterRef == this.offlineSearchText)[0];
          let id = null;

          if (temp != null && temp.bulkConnectionId != null && temp.connType == 2) //is bulk meter
            id = temp.connectionId.toString();

          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.bulkConnectionId.toString() == id || r.connectionId.toString() == id);
          break;
      }
      this.advancedSearchResults.sort((a, b) => a.sequence < b.sequence);
    },
    clearAdvancedSearch() {
      this.lastSelectedReading = null;
      this.offlineSearchText = '';
      this.offlineSearchType = 'meterNo';
      this.loadSearchList = false;
      this.loadSearchListIsDisabled = false;
      this.advancedSearchResults = [];
      this.isSearched = false;
    },
    readingSelected(item) {
      if (!item) {
        this.lastSelectedReading = null;
        return;
      }
      
      if (this.saveSearch === true)
        this.saveSeachToStore();

      this.lastSelectedReading = item;
      //this.clearAdvancedSearch();
      this.readingSelectedFunc(item, this.filtersDataObj);
    },
    getClassBillGroups(id) {
      return 'md-primary';
    },
    isLastSelected(item) {
      if (this.lastSelectedReading == null || !item)
        return null;

      if (this.lastSelectedReading.meterRef == item.meterRef && this.lastSelectedReading.meterId == item.meterId) {
        return 'selected-reading';
      }
      else
        return null;
    },
    close() {
      this.clearAdvancedSearch();
      this.$emit('closeDialog');
    },
    saveSeachToStore() {
      this.$store.commit('setCaptureMeterReadingsSearch', { offlineSearchType: this.offlineSearchType, offlineSearchText: this.offlineSearchText });
    },

  }
}
